import { motion } from 'framer-motion';
import { useScrollAnimation, staggerContainer, fadeInUp } from '../../hooks/useScrollAnimation';
import SectionTitle from '../ui/SectionTitle';
import ProjectRow, { Band } from '../ui/ProjectRow';
import { useLang } from '../context/LanguageContext';
import { projects, otherActivities } from '../../data/projects';

// Verdes y limas casi desvanecidos; cada fila toma el siguiente tono.
const TINTS = ['#F2F8EA', '#EAF5EE', '#F5F9E3', '#E8F3EA', '#F0F7E6', '#EDF6F0'];

const GroupHeading = ({ title, intro, className = '' }) => (
  <motion.div variants={fadeInUp} className={`mb-10 md:mb-14 ${className}`}>
    <h3 className="flex items-center gap-5">
      <span className="font-display text-2xl md:text-3xl font-bold text-primary">{title}</span>
      <span className="flex-1 h-px bg-primary/15" aria-hidden="true" />
    </h3>
    {intro && <p className="text-gray-600 text-base md:text-lg leading-relaxed max-w-3xl mt-4">{intro}</p>}
  </motion.div>
);

const ProjectsSection = ({ id }) => {
  const { ref, inView } = useScrollAnimation();
  const { t, lang } = useLang();
  const others = otherActivities[lang] || otherActivities.es;

  const enCurso = projects.filter((p) => p.status === 'curso');
  const pasados = projects.filter((p) => p.status === 'pasado');

  return (
    <section id={id} className="section-padding bg-white overflow-hidden" ref={ref}>
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        className="container-max"
      >
        <SectionTitle title={t.projects.title} />

        <GroupHeading title={t.projects.currentTitle} intro={t.projects.currentIntro} />
        <div>
          {enCurso.map((project, i) => (
            <ProjectRow key={project.id} project={project} tint={TINTS[i % TINTS.length]} reverse={i % 2 === 1} />
          ))}
        </div>

        <GroupHeading className="mt-16 md:mt-24" title={t.projects.pastTitle} intro={t.projects.pastIntro} />
        {/* Trayectoria: filas más compactas y angostas */}
        <div className="max-w-5xl mx-auto">
          {pasados.map((project, i) => (
            <ProjectRow
              key={project.id}
              project={project}
              tint={TINTS[(enCurso.length + i) % TINTS.length]}
              reverse={i % 2 === 1}
              compact
            />
          ))}

          <Band tint={TINTS[(enCurso.length + pasados.length) % TINTS.length]} className="py-10 md:py-12">
            <h4 className="font-display text-xl md:text-2xl font-bold text-primary mb-5">{others.title}</h4>
            <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-3">
              {others.items.map((item) => (
                <li key={item} className="flex items-start gap-3 text-gray-600 text-[15px]">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent flex-shrink-0 mt-2.5" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </Band>
        </div>
      </motion.div>
    </section>
  );
};

export default ProjectsSection;
